import { UserModel } from 'src/api/model/user';
import { RequestBuilder } from 'src/api/common/request-builder';
// import { UserModule } from '@/store/modules/user'
import { UserSearchForm } from 'src/api/model/search/user-search-form';
import { Pagable } from 'src/constants/pagable';
import { RequestUtils } from 'src/utils/request-utils';
import { UserForm } from 'src/api/model/form/user-form';
import { UserData } from 'src/api/model/response/user-data';
import { UserRoleForm } from '../model/form/user-role-form';
import { Page } from '../common/page';
import { UserStatisticResponse } from '../model/response/user-statistic-response';
import { PasswordRequestStatisticResponse } from '../model/response/password-request-statistic-response';
import request from 'src/utils/request';

export class UserApi {
  getData(
    form: UserSearchForm,
    pagable: Pagable,
  ): Promise<UserModel[]> {
    const params = RequestUtils.merge(
      form,
      RequestUtils.initPageableParams(pagable),
    );
    return new RequestBuilder<UserModel>()
      .url('/member/user/getData')
      .config({ params: params })
      .findAll();
  }

  getPaging(
    form: UserSearchForm,
    pagable: Pagable,
  ): Promise<Page<UserModel>> {
    const params = RequestUtils.merge(
      form,
      RequestUtils.initPageableParams(pagable),
    );
    return new RequestBuilder<UserModel>()
      .url('/api/users')
      .config({ params: params })
      .findAllPagging();
  }

  findAllAdmin(
    form: UserSearchForm,
    pagable: Pagable,
  ): Promise<UserModel[]> {
    const params = RequestUtils.merge(
      form,
      RequestUtils.initPageableParams(pagable),
    );
    return new RequestBuilder<UserModel>()
      .url('/member/user/findAllAdmin')
      .config({ params: params })
      .findAll();
  }

  findAllMember(
    form: UserSearchForm,
    pagable: Pagable,
  ): Promise<Page<UserModel>> {
    const params = RequestUtils.merge(
      form,
      RequestUtils.initPageableParams(pagable),
    );
    return new RequestBuilder<UserModel>()
      .url('/member/user/findAllMember')
      .config({ params: params })
      .findAllPagging();
  }

  findById(id: string): Promise<UserModel> {
    return new RequestBuilder<UserModel>()
      .url(`/member/user/${id}`)
      .findOne();
  }

  findByUsername(username: string): Promise<UserModel> {
    return new RequestBuilder<UserModel>()
      .url(
        `/member/user/findByUsername?username=${username}`,
      )
      .findOne();
  }

  saveNotificationToken(data: any) {
    return new RequestBuilder<UserModel>()
      .url('/member/user/activity')
      .data(data)
      .post();
  }

  save(form: any) {
    return new RequestBuilder<UserModel>()
      .url('api/users')
      .data(form)
      .post();
  }

  register(form: any) {
    let data = { ...form };
    //Đặt email là username luôn
    data.username = form.email;

    return new RequestBuilder<UserModel>()
      .url('api/auth/register')
      .data(data)
      .post();
  }

  update(id: string, form: UserForm) {
    return new RequestBuilder<UserModel>()
      .url(`api/users/${id}`)
      .data(form)
      .put();
  }

  delete(id: string) {
    return new RequestBuilder<UserModel>()
      .url(`api/users/${id}`)
      .delete();
  }

  getUsers(): Promise<any> {
    return new RequestBuilder<any>()
      .url(`/api/users`)
      .findAll();
  }

  getUserStatistics(): Promise<any> {
    return new RequestBuilder<UserStatisticResponse>()
      .url('/api/users/statistics')
      .get();
  }

  getUsersInDept(id: string): Promise<UserData[]> {
    return new RequestBuilder<UserData>()
      .url(`/member/user/allDataInDept/${id}`)
      .findAll();
  }

  getUsersInDeptIds(ids: string[]): Promise<string[]> {
    return new RequestBuilder<string>()
      .url(`/member/user/getUsersInDeptIds/`)
      .config({ params: { ids: ids } })
      .findAll();
  }

  getUsersInDepts(ids: string[]): Promise<UserData[]> {
    return new RequestBuilder<UserData>()
      .url(`/member/user/allDataInDepts`)
      .config({ params: { ids: ids } })
      .findAll();
  }

  getDepts(id: string): Promise<string[]> {
    return new RequestBuilder<string>()
      .url(`/member/user/getDepts`)
      .config({ params: { userId: id } })
      .findAll();
  }

  resetPassword(userId: string, newPassword: string, oldPassword: string): Promise<any> {
    return new RequestBuilder<any>()
      .url(`/api/users/${userId}/reset-password`)
      .data({ newPassword, oldPassword })
      .put();
  }

  setPassword(userId: string, newPassword: string): Promise<any> {
    return new RequestBuilder<any>()
        .url(`/api/users/${userId}/set-password`)
        .data({ newPassword })
        .put();
  }

  changePassword(userId: string, oldPassword: string, newPassword: string): Promise<any> {
    return new RequestBuilder<any>()
      .url('/api/auth/changePassword')
      .config({ 
        params: { 
          userId, 
          oldPassword, 
          newPassword 
        } 
      })
      .post();
  }

  changeMyPassword(oldPassword: string, newPassword: string): Promise<any> {
    return request({
      url: '/api/auth/me/changePassword',
      method: 'post',
      data: { oldPassword, newPassword },
    });
  }

  ssoChangePassword(oldPassword: string, newPassword: string): Promise<any> {
    return request({
      url: '/api/auth/ssoChangePassword',
      method: 'post',
      data: { oldPassword, newPassword },
      withCredentials: true,
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
      },
    });
  }

  forgotPassword(email: string): Promise<any> {
    return new RequestBuilder<any>()
      .url('/api/auth/forgotPassword?email=' + email)
      .post();
  }


  submitPasswordRequest(data: {
    fullName: string;
    email: string;
    phoneNumber: string;
  }): Promise<any> {
    return new RequestBuilder<any>()
      .url('/api/auth/password-request')
      .data(data)
      .post();
  }


  getPasswordRequests(params?: {
    page?: number;
    size?: number;
    status?: string;
    keyword?: string;
  }): Promise<any> {
    return new RequestBuilder<any>()
      .url('/api/auth/password-requests')
      .config({ params })
      .findAllPagging();
  }


  updatePasswordRequestStatus(requestId: string, status: string): Promise<any> {
    return new RequestBuilder<any>()
      .url(`/api/auth/password-requests/${requestId}/status`)
      .data({ status })
      .put();
  }


  getPasswordRequestStatistics(): Promise<any> {
    return new RequestBuilder<PasswordRequestStatisticResponse>()
      .url('/api/auth/password-requests/statistics')
      .get();
  }
}

export const userApi = new UserApi();
